export enum NachrichtStateEnum{
    PREPARE = 'prepare',
    FORM = 'form'
}
